import React from 'react';
import c from 'classnames';
import { Menu, CoreLink } from '@uncinc/react-drupal-core';
import { useDispatch } from 'react-redux';
import { Logo } from '../../components';
import { trackEvent } from '../../actions/UI';

import './style.scss';

const BottomFooterMenuItem = ({ item }) => {
  const title = item.getIn(['link', 'title'], 'Untitled');
  const url = item.getIn(['link', 'url']);
  const linkClass = item.getIn(['link', 'options', 'attributes', 'class'], ['']);
  const containerClass = item.getIn(['link', 'options', 'container_attributes', 'class', 0], '');
  const containerClassName = c('NavigationFooterMenuBottom__item', containerClass);
  const itemClassName = c('NavigationFooterMenuBottom__item__link__title', ...linkClass);

  return (
    <div key={title} className={containerClassName}>
      <CoreLink className="NavigationFooterMenuBottom__item__link" to={url}>
        <div className={itemClassName}>{title}</div>
      </CoreLink>
    </div>
  );
};

const Footer = () => {
  const dispatch = useDispatch();

  const NEWSLETTER_TITLE = 'nieuwsbrief';
  const MEMBER_URL_PARTIAL = '-lid';
  const SOCIAL_TITLES = [
    'Linkedin',
    'Youtube',
    'Rss',
    'Twitter',
  ];

  return (
    <footer className="Footer col-12">
      <div className="Footer__content Footer__content--top">
        <Menu id="footer-navigation">
          {(items) => {
            return (
              <div className="row">
                <div className="Footer__logo-container col-12 col-md-6 col-lg-3">
                  <div className="Footer__logo-container__inner">
                    <Logo type="footer" />
                  </div>
                </div>
                {items.map((item) => {
                  const title = item.getIn(['link', 'title'], 'Untitled');

                  return (
                    <div key={title} className="NavigationFooterMenu__main__item col-12 col-md-6 col-lg-3">
                      {item.get('has_children') ? (
                        item.get('subtree').map((subItem) => {
                          const key = `${subItem.get('depth')}:${subItem.getIn(['link', 'weight'])}`;
                          const classes = c('NavigationFooterMenu__item', subItem.getIn(['link', 'options', 'attributes', 'class', 0], ''));
                          const url = subItem.getIn(['link', 'url'], '');
                          const linkTitle = subItem.getIn(['link', 'title'], 'Untitled');
                          let fn = () => { };

                          if (url.includes(NEWSLETTER_TITLE)) {
                            fn = () => {
                              dispatch(trackEvent('Nieuwsbrief', 'Klik op nieuwsbrief link in footer', 'Nieuwsbrief', null));
                            };
                          } else if (url.includes(MEMBER_URL_PARTIAL)) {
                            fn = () => {
                              dispatch(trackEvent('Lid', 'Klik op "word lid" knop', 'Word lid', null));
                            };
                          } else if (SOCIAL_TITLES.includes(linkTitle)) {
                            fn = () => {
                              dispatch(trackEvent('Social', `Klik op ${linkTitle} social icon in footer`, 'Social', linkTitle));
                            };
                          }

                          return (
                            <div key={key} className={classes} onClick={fn}>
                              <CoreLink className="NavigationFooterMenu__item__link" to={url}>
                                <div className="NavigationFooterMenu__item__link__title">{linkTitle}</div>
                              </CoreLink>
                            </div>
                          );
                        })
                      ) : null}
                    </div>
                  );
                })}
              </div>
            );
          }}
        </Menu>
      </div>
      <div className="Footer__content Footer__content--bottom">
        <Menu id="footer-navigation-bottom">
          {(items) => items.map((item) => <BottomFooterMenuItem key={item.getIn(['link', 'title'], 'Untitled')} item={item} />)}
        </Menu>

        <Menu id="footer-navigation-certificates">
          {(items) => items.map((item) => <BottomFooterMenuItem key={item.getIn(['link', 'title'], 'Untitled')} item={item} />)}
        </Menu>
      </div>
    </footer>
  );
};

export default Footer;
